import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";


interface IProps {
    id: number,
    url: string
}
export  class FieldClassificationTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item">
                <NavLink to={"/field-classification/field-classification-form/" + this.props.id} className={this.props.url=="/field-classification/field-classification-form/"?"nav-link active":"nav-link"} id="show-tab" data-toggle="tab" href="#edit" role="tab"
                    aria-controls="edit" aria-selected={this.props.url=="/field-classification/field-classification-form/"?"true":"false"}><i className="far fa-edit"></i>&nbsp;Edit</NavLink>
            </li>
                <li className="nav-item">
                    <NavLink to={"/field-classification/detail/" + this.props.id} className={this.props.url == "/field-classification/detail/" ? "nav-link active" : "nav-link"} id="detail-tab" data-toggle="tab" href="#edit" role="tab"
                        aria-controls="detail" aria-selected={this.props.url == "/field-classification/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                </li>
            </ul>
            <br />
        </Fragment>
        )
    }
}
